<div class="lm-overlay" (click)="closed.emit()">
  <div class="lm-modal" role="dialog" aria-modal="true" [attr.aria-label]="document.title" (click)="$event.stopPropagation()">
    <div class="lm-header">
      <h3 class="lm-title">{{ document.title }}</h3>
      <button type="button" class="lm-close" aria-label="Close" (click)="closed.emit()">
        <i-tabler name="x" style="width:18px;height:18px;"></i-tabler>
      </button>
    </div>

    <div class="lm-body">
      <p class="lm-scope">{{ document.scopeLine }}</p>
      <p class="lm-version">Version {{ document.version }}</p>

      <section *ngFor="let section of sections" class="lm-section">
        <h4 class="lm-section-heading">{{ section.heading }}</h4>
        <p *ngFor="let paragraph of section.paragraphs" class="lm-paragraph">
          <ng-container *ngFor="let part of paragraph">
            <a *ngIf="part.email; else plainText" class="lm-link" [href]="'mailto:' + part.text">{{ part.text }}</a>
            <ng-template #plainText>{{ part.text }}</ng-template>
          </ng-container>
        </p>
      </section>

      <a class="lm-link lm-full-page" [href]="pageUrl" target="_blank" rel="noopener">
        Open the full page on studioip.ai
      </a>
    </div>

    <div class="lm-footer">
      <button *ngIf="showAgree" type="button" class="lm-btn-agree" (click)="agreed.emit()">I agree</button>
      <button type="button" class="lm-btn-close" (click)="closed.emit()">Close</button>
    </div>
  </div>
</div>
